import { PageTypes } from '@core/constants/pages'
import type { RouteRecordRaw } from 'vue-router'

const RedirectPage = async () => import('./redirect.vue')

const routes: RouteRecordRaw[] = [
  {
    name: 'redirect',
    path: `/redirect/:providerSlug`,
    meta: { pageType: PageTypes.REDIRECT },
    component: RedirectPage,
  },
]

export default routes
